import { Col, Row } from "reactstrap"
import Item from "./Item"
import React, { useEffect, useState } from "react"
import { AvField } from "availity-reactstrap-validation"

const OtherConsumptionItems = props => {
  const [otherItems, setotherItems] = useState([])
  const [currentItem, setcurrentItem] = useState("")
  const [itemsDiv, setitemsDiv] = useState()

  useEffect(() => {
    setcurrentItem("")
    populateItemsDiv(props.data.data)
  }, [props.data])

  const addItem = () => {
    if (currentItem == "" || checkDuplicate(currentItem)) {
      setcurrentItem("")
      return
    }

    props.add(currentItem)
  }

  const checkDuplicate = itemName => {
    let status = false

    otherItems.forEach(item => {
      if (item.name == itemName) {
        status = true
        return
      }
    })

    return status
  }

  const changeCurrentItem = e => {
    let item = e.target.value.trim()
    if (item == "") {
      return
    }
    setcurrentItem(item)
  }

  const updateItem = item => {
    props.update(item)
  }

  const populateItemsDiv = otherItems => {
    let divItems = otherItems.map((item, index) => {
      return (
        <Item
          key={index}
          index={index}
          checked={item.checked}
          value={item.name}
          update={updateItem}
        />
      )
    })

    setitemsDiv(divItems)
  }

  return (
    <>
      {itemsDiv}
      <div>
        <Row>
            <h6>Use the box below to enter items not displayed in the list above</h6>
          <Col md={8}>
            <AvField
              type="text"
              name="consumption_item"
              placeholder="Enter custom consumption area item"
              value={currentItem}
              onChange={changeCurrentItem}
            ></AvField>
          </Col>

          <Col md={4}>
            <a className="btn btn-primary" onClick={addItem}>
              Add
            </a>
          </Col>
        </Row>
      </div>
    </>
  )
}

export default OtherConsumptionItems
